import { Box, Container, Divider, Grid, Typography } from '@mui/material'
import { useTranslation } from 'react-i18next'
import SeminarInterface from '../../../../backoffice/seminars/models/Seminars'
import NotFilter from '../../../../shared/components/NotFilter'
import SeminarCard from './SeminarCard'
import 'react-responsive-carousel/lib/styles/carousel.min.css'
import useScreenWidth from '../../../../shared/hooks/useScreenWidth'
import { CarouselStyled } from '../../../../shared/styles/SeminarGlobalStyles'
import { SeminarPanelProps } from '../../models/seminar'

function SeminarPanel({ highlightSeminars, seminars, loading, subsection }: SeminarPanelProps) {
  const { t } = useTranslation(['global'])
  const isMobile = useScreenWidth(700)

  return (
    <Container style={{ maxWidth: 1111 }}>
      {highlightSeminars.length === 1 && (
        <Box mt={isMobile ? 0 : 3} mb={isMobile ? 2 : 0}>
          <SeminarCard type={0} seminar={highlightSeminars[0]} />
        </Box>
      )}

      {highlightSeminars.length >= 2 && (
        <>
          <Box display="flex" alignItems="center">
            <Typography variant="h6" style={{ minWidth: 'fit-content' }}>
              {t('featured')}
            </Typography>
            <Divider style={{ marginLeft: 16, flexShrink: 1 }} />
          </Box>
          <Grid container item alignContent="flex-start" style={{ padding: '1rem' }}>
            <Grid item xs={isMobile && highlightSeminars.length >= 7 ? 8 : 12}>
              <CarouselStyled centerMode={!isMobile} autoPlay={true} showArrows={!isMobile} interval={5000} infiniteLoop>
                {highlightSeminars.map((seminar: SeminarInterface) => (
                  <SeminarCard type={0} seminar={seminar} key={seminar.id} />
                ))}
              </CarouselStyled>
            </Grid>
          </Grid>
        </>
      )}

      {highlightSeminars.length > 0 && (
        <Box display="flex" alignItems="center" py={1} pb={3}>
          <Typography variant="h6" style={{ minWidth: 'fit-content' }}>
            {t('last-seminars')}
          </Typography>
          <Divider style={{ marginLeft: 16, flexShrink: 1 }} />
        </Box>
      )}

      {seminars.length === 0 && !loading ? (
        <NotFilter subsection={subsection} />
      ) : (
        <Grid container spacing={isMobile ? 1 : 3} direction="row">
          {seminars.map((seminar: SeminarInterface, _index: number) => (
            <Grid item xs={6} sm={4} lg={3} key={seminar.id}>
              <SeminarCard type={1} seminar={seminar} />
            </Grid>
          ))}
        </Grid>
      )}
    </Container>
  )
}

export default SeminarPanel
